import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

const styles: ComponentStylesProps<string> = {
  card: {
    borderRadius: '10px',
    padding: '2rem 2rem 1.6rem 2rem',
    width: '13.6rem',
    textAlign: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'grid',
    gridTemplateRows: '4rem auto',
    justifyItems: 'center',
    [breakpoints.sm.down]: {
      padding: '1rem 2rem',
    },
    '@media(max-width: 468px)': {
      width: '100%',
    },
  },
  defaultCard: { color: colors.blue[600], backgroundColor: colors.blue[100] },
  cardTitle: {
    font: { size: '1.2rem', lineHeight: '1.8rem', weight: 700 },
    letterSpacing: '0.03rem',
    textTransform: 'uppercase',
    [breakpoints.sm.down]: {
      marginBottom: '0',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
